/**
 * How a retained selection enters the chat: quoted, as a markdown blockquote,
 * with the question after it. Prompt text rather than a `content_context` on
 * purpose — a context on the main chat switches the agent into content mode
 * and binds the conversation to a content row; a quote is just words.
 */

/**
 * Compose the message for a selection: `> ` on every line, a blank line, then
 * `question` (empty by default, so the composer's caret lands where the user
 * types).
 */
export function composeSelectionPrompt(selection: string, question = ''): string {
  const quoted = selection
    .trim()
    .split('\n')
    .map(line => `> ${line}`)
    .join('\n');
  return `${quoted}\n\n${question}`;
}
